import { render, staticRenderFns } from "./satuan.vue?vue&type=template&id=3c0785a3&"
import script from "./satuan.vue?vue&type=script&lang=js&"
export * from "./satuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports